
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import RiderServices from "../services/externalServices/riderServices";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import { DriveFileMoveRounded, QrCodeScannerOutlined } from "@mui/icons-material";
import Rating from '@mui/material/Rating';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from "@mui/material";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";

function StickyHeadTable() {
  const dispatch = useDispatch();
  const {serviceType}= useSelector((state) => state.serviceType.serviceType);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [driverData, setDriverData] = useState([]);
  const [activeDrivers, setActiveDrivers] = useState([]);
  const [availableDrivers, setAvailableDrivers] = useState([]);
  const [inActiveDrivers, setInActiveDrivers] = useState([]);
  const [totalDrivers, setTotalDrivers] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("totalDrivers");
  const [searchQuery, setSearchQuery] = useState("");
  const [pendingDrivers,setPendingDrivers]=useState();

  useEffect(() => {
    fetchData();
  }, [serviceType]);

  async function fetchData() {
    try {
      const riders = await RiderServices.getDrivers(serviceType);

      setTotalDrivers(riders);

      const activeDrivers = riders.filter(
        (driver) => driver.is_online && driver.isOccupied && driver.is_approved && driver.serviceAssociated===serviceType
      );
      setActiveDrivers(activeDrivers);

      const availableDrivers = riders.filter(
        (driver) => driver.is_online && !driver.isOccupied && driver.is_approved &&driver.serviceAssociated===serviceType
      );
      setAvailableDrivers(availableDrivers);

      const inActiveDrivers = riders.filter((driver) => !driver.is_online && driver.is_approved &&driver.serviceAssociated===serviceType);
      setInActiveDrivers(inActiveDrivers);

      const pendingDrivers=riders.filter((driver)=>!driver.is_approved);
      setPendingDrivers(pendingDrivers);

      setDriverData(riders.map(createData));
    } catch (err) {
      console.log("Error while fetching the active drivers", err);
    }
  }

  const createData = (driver) => {
    const {
      _id,
      first_name,
      last_name,
      phone_number,
      vehicle_name,
      vehicle_number,
      rating,
      // status,
      is_approved,
      created_at,
      lastAccessed 
    } = driver;

    const name = `${first_name} ${last_name}`;
    return {
      id: _id,
      name,
      phonenumber: phone_number,
      vehicle: vehicle_name,
      vehicle_number,
      rating,
      // status,
      is_approved,
      created_at,
      lastAccessed

      
    };
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    switch (category) {
      case "active":
        setDriverData(activeDrivers.map(createData));
        break;
      case "available":
        setDriverData(availableDrivers.map(createData));
        break;
      case "inactive":
        setDriverData(inActiveDrivers.map(createData));
        break;
      case "totalDrivers":
        setDriverData(totalDrivers.map(createData));
        break;
      case "pendingDriver": 
        setDriverData(pendingDrivers.map(createData));
        break;
      default:
        break;
    }
  };

  const filteredDrivers = driverData.filter((driver) => {
    // Convert searchQuery to string to handle number inputs
    const query = searchQuery.toString().toLowerCase();
  
    console.log("filteredDrivers  query",driver.phonenumber)
    // Ensure both name and phone_number exist and check for matches
    const matchesName = driver.name && driver.name.toLowerCase().includes(query);
    const matchesPhone = driver.phonenumber && driver.phonenumber.toString().includes(query);

  
    console.log("matchesPhone",matchesPhone)
    return matchesName || matchesPhone;
    // return matchesName ;
  });
  

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (pageSize) => {
    setRowsPerPage(pageSize);
    setPage(0);
  };

  const handleApproval = async (driverId, isApproved) => {
    console.log("Is approved value",isApproved);
    try {
      // Make an API call to update the driver's approval status
      // For example:
     const response= await RiderServices.updateRider(driverId,  { is_approved:isApproved });
  
      // Update the driver's approval status in the local state
      console.log("response for approval of rider",response)
      const updatedDriverData = driverData.map((driver) => {
        if (driver.id === driverId) {
          return { ...driver, is_approved: isApproved };
        }
        return driver;
      });
      setDriverData(updatedDriverData);
    } catch (error) {
      console.error("Error updating driver approval:", error);
    }
  };

  const columns = [
    { field: "slNo", headerName: "SL No.", width: 100 },
    { field: "name", headerName: "Name", width: 170,
    },
    { field: "phonenumber", headerName: "Phone Number", width: 150,
      renderCell: (params) => (
        <Link to={`/riders/${params.row.id}`} className="text-decoration-none text-dark font-weight-bold">{params.value}</Link>
      )
     },
    { field: "vehicle", headerName: "Vehicle", width: 150 },
    { field: "vehicle_number", headerName: "Vehicle Number", width: 150 },
 
    { field: "rating", headerName: "Rating", width: 150,
    renderCell: (params) => (
      <Rating name="read-only" value={params.value} readOnly />
    )
  },
    // { field: "status", headerName: "Status", width: 150 },
    {field: "is_approved", headerName:"Approved",width:120,
    renderCell: (params) => (
      
      <Switch
    checked={params.value}
    onChange={(e) => handleApproval(params.row.id, e.target.checked)}
    sx={{ color: params.value ? "green" : "red" }}
  />
    )},
    { 
      field: "created_at", 
      headerName: "Join Date", 
      width: 150,
      renderCell: (params) => {
        // console.log("Created At Value:", params);
        return (
          <Typography variant="body2" mt={2}>
            {params.value ? moment(params.value).format('YYYY-MM-DD HH:MM') : 'N/A'}
          </Typography>
        );
      }
    },
    { field: "lastAccessed", headerName: "Last Accessed", width: 150,
      renderCell:(params)=>{
        return(
<Typography variant="body2" mt={2}>
{params.value ? params.value : 'N/A'}
      </Typography>
        )
        
      }
     },
    
  ];

  const rows = filteredDrivers.map((driver, index) => ({
    id: index + 1,
    slNo: page * rowsPerPage + index + 1, // Calculate serial number based on page and rowsPerPage
    ...driver,
  }));

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", marginTop:"23px" }}>
      {/* <nav>
        <ol className="breadcrumb d-none d-lg-flex ms-3">
          <li className="breadcrumb-item">
            <i className="bi bi-house lh-1"></i>
            <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>Home</Link>
          </li>
          <li className="breadcrumb-item opacity-50">Riders</li>
        </ol>
      </nav> */}
      <nav mt-3>
  <ol className="breadcrumb d-flex"> {/* Change here */}
    <li className="breadcrumb-item">
      <i className="bi bi-house lh-1"></i>
      <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>
        Home
      </Link>
    </li>
    <li className="breadcrumb-item opacity-50">Riders</li>
  </ol>
</nav>

    
      <div style={{ display: "flex", gap: "10px" }}>
        
  <div className="headers">
    <Select
      value={selectedCategory}
      onChange={(e) => handleCategoryChange(e.target.value)}
      displayEmpty
      inputProps={{ "aria-label": "Without label" }}
      sx={{ fontSize: '15px', padding: "0px", }}
    >
      <MenuItem value="totalDrivers">Total Drivers</MenuItem>
      <MenuItem value="active">In Transit Drivers</MenuItem>
      <MenuItem value="available">Available Drivers</MenuItem>
      <MenuItem value="inactive">Inactive Drivers</MenuItem>
      
      <MenuItem value="pendingDriver">Pending Drivers</MenuItem>
    </Select>
  </div>

  <div className="col-md-auto">
    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
      {/* <SearchIcon sx={{ color: "action.active", mr: 2.5, my: 0.5 }} /> */}
      <TextField
        id="input-with-sx"
        label="Search Driver"
        variant="filled"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        InputProps={{
          startAdornment: (
            <SearchIcon sx={{ color: "action.active", position: "relative", top: "8px" }} />
          ),
        }}
  
      />
    </Box>
  </div>
</div>

      <div style={{ height: 440, width: "100%" }}>
        {filteredDrivers.length>0?(
          <DataGrid
          rows={rows}
          columns={columns}
          pagination
          pageSize={rowsPerPage}
          rowCount={filteredDrivers.length}
          paginationMode="server"
          onPageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPageChange}
          page={page}
        />
        ):(
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          {/* <CircularProgress /> */}
          <Typography>No drivers avilable at the moment</Typography>
        </Box>
        )}
        
      </div>
    </Paper>
  );
}

export default StickyHeadTable;

